export const ACCOUNT_SUMMARY_REQUEST_START: string = 'account/summary/REQUEST_START';
export const ACCOUNT_SUMMARY_REQUEST_FAIL: string = 'account/summary/REQUEST_FAIL';
export const ACCOUNT_SUMMARY_REQUEST_SUCCESS: string = 'account/summary/REQUEST_SUCCESS';

export const ACCOUNT_COMMISSIONS_PENDING: string = 'account/commissions/ACCOUNT_COMMISSIONS_PENDING';
export const ACCOUNT_COMMISSIONS_FAIL: string = 'account/commissions/ACCOUNT_COMMISSIONS_FAIL';
export const ACCOUNT_COMMISSIONS_SUCCESS: string = 'account/commissions/ACCOUNT_COMMISSIONS_SUCCESS';

export const ACCOUNT_COMMISSIONS_DATA_RESET: string = 'account/commissions/reset';